import "./Hero.css";

export default function Hero() {
  return (
    <section className="hero" id="home">
      <div
        className="hero-media"
        style={{
          backgroundImage: 'url("/images/her.png"), url("/images/hero.jpg")',
        }}
      />
      <div className="hero-overlay" />
      <div className="hero-content">
        <h1>
          A Better Life Starts with a
          <br />
          Beautiful Smile
        </h1>
        <a href="#appointment" className="btn">
          Book An Appointment
        </a>
      </div>
    </section>
  );
}
